import PropTypes from 'prop-types';

PropTypes.children = PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
]);

export default PropTypes;